import React from 'react';
import { useDemo } from '../../contexts/DemoContext';
interface Props {
  activePhrases: number;
  representative?: boolean;
}
export function SourceCard({
  activePhrases,
  representative = false
}: Props) {
  const {
    bundle
  } = useDemo();
  const phrases = bundle.highlightPhrases;

  // Splits each paragraph on the tracked phrases so they can be underlined in sequence.
  const renderParagraph = (text: string, key: number) => {
    const pattern = new RegExp(`(${phrases.join('|')})`, 'g');
    const parts = text.split(pattern);
    return <p key={key} className="mb-3.5 text-[13px] leading-relaxed text-ink/85 last:mb-0" data-id="element-81" data-mp="2um5aycmomuec">
        {parts.map((part, i) => {
        const phraseIndex = phrases.indexOf(part);
        if (phraseIndex === -1) return <React.Fragment key={i} data-id="element-82" data-mp="2locw19kvhorh">{part}</React.Fragment>;
        const on = phraseIndex < activePhrases;
        return <span key={i} className={`phrase ${on ? 'phrase-on' : ''}`} data-id="element-83" data-mp="1a6tlew4yqjiw" data-mpi={i}>
              {part}
            </span>;
      })}
      </p>;
  };
  return <article className="rounded-sm bg-white ring-1 ring-rule" data-id="element-84" data-mp="1qs8cs1ukcn9p">
      <header className="border-b border-rule px-6 py-5" data-id="element-85" data-mp="1mr4t149ea737">
        <p className="eyebrow text-muted" data-id="element-86" data-mp="1mspnyuzmfs1l">
          {representative ? bundle.representativeLabel : 'Job posting'}
        </p>
        <h2 className="mt-2 text-[15px] font-semibold leading-snug text-ink" data-id="element-87" data-mp="1vqi6s94jxhtq">
          {bundle.posting.title}
        </h2>
        <p className="mt-1.5 text-[12px] text-muted" data-id="element-88" data-mp="29phwlk3sw2rh">{bundle.posting.meta}</p>
      </header>
      <div className="px-6 py-5" data-id="element-89" data-mp="25o64n7xgf5g4">
        {bundle.posting.paragraphs.map((p, i) => renderParagraph(p, i))}
      </div>
      <footer className="border-t border-rule px-6 py-3 font-mono-num text-[11px] text-muted/80" data-id="element-90" data-mp="2jg474zwnu33b">
        {bundle.sourceId} ·{' '}
        {representative ? 'library sample for this role' : 'rendered from source'}
      </footer>
    </article>;
}